import { render, staticRenderFns } from "./FeesForPaidPassengersMasterPage.vue?vue&type=template&id=50e44ed8&scoped=true&"
import script from "./FeesForPaidPassengersMasterPage.vue?vue&type=script&lang=js&"
export * from "./FeesForPaidPassengersMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForPaidPassengersMasterPage.vue?vue&type=style&index=0&id=50e44ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e44ed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e44ed8')) {
      api.createRecord('50e44ed8', component.options)
    } else {
      api.reload('50e44ed8', component.options)
    }
    module.hot.accept("./FeesForPaidPassengersMasterPage.vue?vue&type=template&id=50e44ed8&scoped=true&", function () {
      api.rerender('50e44ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/feeMaster/feesForPaidPassengersMaster/FeesForPaidPassengersMasterPage.vue"
export default component.exports